import { render, staticRenderFns } from "./colorList.vue?vue&type=template&id=b523bc68&scoped=true&"
import script from "./colorList.vue?vue&type=script&lang=js&"
export * from "./colorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b523bc68",
  null
  
)

export default component.exports